import { eGameRequest, proto } from '../../main'
/**
 * 获取赛事列表
 */
export function gameMatchSearchList (query) {
  const pbReq = proto.create('fwGame.PBAdminMatchSearchReq', query)
  return eGameRequest('fwGame.gameMatchSearchList', pbReq, 'fwGame.PBAdminMatchList')
}

export function gameMatchInfo (param) {
  const pbReq = proto.create('fwGame.PBAdminMatchInfoReq', param)
  return eGameRequest('fwGame.gameMatchInfo', pbReq, 'fwGame.PBAdminMatch')
}

/**
 * 赔率数据
 * @param {PBAdminBetInfoReq} query
 */
export function gameBetInfo (query) {
  const pbReq = proto.create('fwGame.PBAdminBetInfoReq', query)
  return eGameRequest('fwGame.gameBetInfo', pbReq, 'fwGame.PBAdminBet')
}

export function gameBetSearchList (query) {
  const pbReq = proto.create('fwGame.PBAdminBetSearchReq', query)
  return eGameRequest('fwGame.gameBetSearchList', pbReq, 'fwGame.PBAdminBetList')
}

/**
 * 手动修改记录
 * @param {PBManualRecordSearchReq} param
 */
export function manualRecordList (param) {
  const pbReq = proto.create('fwGame.PBManualRecordSearchReq', param)
  return eGameRequest('fwGame.manualRecordList', pbReq, 'fwGame.PBManualRecordList')
}
/**
 * 联赛数据
 */
export function gameLeagueSearchList (param) {
  const pbReq = proto.create('fwGame.PBAdminLeagueSearchReq', param)
  return eGameRequest('fwGame.gameLeagueSearchList', pbReq, 'fwGame.PBAdminLeagueList')
}

export function gameLeagueInfo (param) {
  const pbReq = proto.create('fwGame.PBAdminLeagueInfoReq', param)
  return eGameRequest('fwGame.gameLeagueInfo', pbReq, 'fwGame.PBAdminLeague')
}

/**
 * 战队数据(根据条件查询战队数据/获取战队的信息)
 * @param {PBAdminTeamSearchReq/PBAdminTeamInfoReq} param
 */
export function gameTeamSearchList (param) {
  const req = proto.create('fwGame.PBAdminTeamSearchReq', param)
  return eGameRequest('fwGame.gameTeamSearchList', req, 'fwGame.PBAdminTeamList')
}

export function gameTeamInfo (param) {
  const req = proto.create('fwGame.PBAdminTeamInfoReq', param)
  return eGameRequest('fwGame.gameTeamInfo', req, 'fwGame.PBAdminTeam')
}

/**
 * 对局数据(获取赛事的对阵信息)
 * @param {PBAdminBattleInfoReq} param
 */
export function gameBattleInfo (param) {
  const req = proto.create('fwGame.PBAdminBattleInfoReq', param)
  return eGameRequest('fwGame.gameBattleInfo', req, 'fwGame.PBAdminBattle')
}

/**
 * 选手数据(根据条件查选手数据/获取选手的信息)
 * @param {PBAdminPlayerSearchReq/PBAdminPlayerInfoReq} param
 */
export function gamePlayerSearchList (param) {
  const req = proto.create('fwGame.PBAdminPlayerSearchReq', param)
  return eGameRequest('fwGame.gamePlayerSearchList', req, 'fwGame.PBAdminPlayerList')
}

export function gamePlayerInfo (param) {
  const req = proto.create('fwGame.PBAdminPlayerInfoReq', param)
  return eGameRequest('fwGame.gamePlayerInfo', req, 'fwGame.PBAdminPlayer')
}

/**
 * 英雄数据(根据条件查英雄数据/获取英雄的信息)
 * @param {PBAdminHeroSearchReq/PBAdminHeroInfoReq} param
 */
export function gameHeroSearchList (param) {
  const req = proto.create('fwGame.PBAdminHeroSearchReq', param)
  return eGameRequest('fwGame.gameHeroSearchList', req, 'fwGame.PBAdminHeroList')
}

export function gameHeroInfo (param) {
  const req = proto.create('fwGame.PBAdminHeroInfoReq', param)
  return eGameRequest('fwGame.gameHeroInfo', req, 'fwGame.PBAdminHero')
}

/**
 * 道具数据(根据条件查询道具数据/获取道具的信息)
 * @param {PBAdminItemSearchReq/PBAdminItemInfoReq} param
 */
export function gameItemSearchList (param) {
  const req = proto.create('fwGame.PBAdminItemSearchReq', param)
  return eGameRequest('fwGame.gameItemSearchList', req, 'fwGame.PBAdminItemList')
}

export function gameItemInfo (param) {
  const req = proto.create('fwGame.PBAdminItemInfoReq', param)
  return eGameRequest('fwGame.gameItemInfo', req, 'fwGame.PBAdminItem')
}

/**
 * 技能数据(根据条件查技能数据/获取技能的信息)
 * @param {PBAdminSkillSearchReq/PBAdminSkillInfoReq} param
 */
export function gameSkillSearchList (param) {
  const req = proto.create('fwGame.PBAdminSkillSearchReq', param)
  return eGameRequest('fwGame.gameSkillSearchList', req, 'fwGame.PBAdminSkillList')
}

export function gameSkillInfo (param) {
  const req = proto.create('fwGame.PBAdminSkillInfoReq', param)
  return eGameRequest('fwGame.gameSkillInfo', req, 'fwGame.PBAdminSkill')
}

/**
 * 符文数据(根据条件查符文数据/获取符文的信息)
 * @param {PBAdminRuneSearchReq/PBAdminRuneInfoReq} param
 */
export function gameRuneSearchList (param) {
  const req = proto.create('fwGame.PBAdminRuneSearchReq', param)
  return eGameRequest('fwGame.gameRuneSearchList', req, 'fwGame.PBAdminRuneList')
}

export function gameRuneInfo (param) {
  const req = proto.create('fwGame.PBAdminRuneInfoReq', param)
  return eGameRequest('fwGame.gameRuneInfo', req, 'fwGame.PBAdminRune')
}

/**
 * 废弃游戏数据
 * @param {PBManualRecordReq} param
 */
export function gameDataTrash (param) {
  console.log('gameDataTrash ====>', param)
  const pbReq = proto.create('fwGame.PBManualRecordReq', param)
  return eGameRequest('fwGame.gameDataTrash', pbReq)
}

/**
 * 恢复游戏数据
 * @param {PBDataNormalReq} param
 */
export function gameDataNormal (param) {
  console.log('gameDataNormal ====>', param)
  const pbReq = proto.create('fwGame.PBDataNormalReq', param)
  return eGameRequest('fwGame.gameDataNormal', pbReq)
}

/**
 * 添加修改记录
 * @param {PBManualRecordReq} param
 */
export function manualRecordAdd (param) {
  const pbReq = proto.create('fwGame.PBManualRecordReq', param)
  return eGameRequest('fwGame.manualRecordAdd', pbReq)
}

/**
 * 删除修改记录
 * @param {PBIntValue} recordId
 */
export function manualRecordDel (record) {
  const pbReq = proto.create('fwGame.PBManualRecord', record)
  return eGameRequest('fwGame.manualRecordDelete', pbReq)
}

/**
 * 重新爬虫
 * @param {PBRestartSpiderReq} param
 */
export function gameDataRestartSpider (param) {
  const pbReq = proto.create('fwGame.PBRestartSpiderReq', param)
  return eGameRequest('fwGame.gameDataRestartSpider', pbReq)
}

export function gameBattleTeamInfo (param) {
  const pbReq = proto.create('fwGame.PBAdminBattleStatsReq', param)
  return eGameRequest('fwGame.gameBattleTeamInfo', pbReq, 'fwGame.PBAdminBattleTeamStatistics')
}

export function gameBattlePlayerInfo (param) {
  const req = proto.create('fwGame.PBAdminBattleStatsReq', param)
  return eGameRequest('fwGame.gameBattlePlayerInfo', req, 'fwGame.PBAdminBattlePlayerStatistics')
}

/**
 * 匹配失败记录
 */
export function mappingFailureRecordList (param) {
  const req = proto.create('fwGame.PBQueryFailureRecordReq', param)
  return eGameRequest('fwGame.mappingFailureRecordList', req, 'fwGame.PBMatchingFailureRecordList')
}
export function mappingFailureRecordProcess (param) {
  const req = proto.create('fwGame.PBProcessFailureRecordReq', param)
  return eGameRequest('fwGame.mappingFailureRecordProcess', req)
}
export function mappingFailureRecordAutoProcess (recordId) {
  const req = proto.create('framework.PBLongValue', { value: Number(recordId) })
  return eGameRequest('fwGame.mappingFailureRecordAutoProcess', req, 'framework.PBLongValue')
}
export function mappingFailureRecordRepeal (recordId) {
  const req = proto.create('framework.PBLongValue', { value: Number(recordId) })
  return eGameRequest('fwGame.mappingFailureRecordRepeal', req)
}
export function mappingFailureRecordUpdateMapping (param) {
  const req = proto.create('fwGame.PBMappingFailureRecordReq', param)
  return eGameRequest('fwGame.mappingFailureRecordUpdateMapping', req)
}

export function mappingNameKeyList (param) {
  const req = proto.create('fwGame.PBQueryNameKeyMappingReq', param)
  return eGameRequest('fwGame.mappingNameKeyList', req, 'fwGame.PBNameKeyMappingList')
}

export function mappingFailureRecordGet (recordId) {
  const req = proto.create('framework.PBLongValue', { value: Number(recordId) })
  return eGameRequest('fwGame.mappingFailureRecordGet', req, 'fwGame.PBMatchingFailureRecord')
}

export function mappingNameKeyUpdate (param) {
  const req = proto.create('fwGame.PBNameKeyMapping', param)
  return eGameRequest('fwGame.mappingNameKeyUpdate', req)
}

export function mappingNameKeyAdd (param) {
  const req = proto.create('fwGame.PBNameKeyMapping', param)
  return eGameRequest('fwGame.mappingNameKeyAdd', req, 'framework.PBLongValue')
}

export function mappingSystemIdList (param) {
  const req = proto.create('fwGame.PBQuerySystemIdMappingReq', param)
  return eGameRequest('fwGame.mappingSystemIdList', req, 'fwGame.PBSystemIdMappingList')
}

export function mappingSystemIdUpdate (param) {
  const req = proto.create('fwGame.PBSystemIdMapping', param)
  return eGameRequest('fwGame.mappingSystemIdUpdate', req)
}

export function mappingSystemIdAdd (param) {
  const req = proto.create('fwGame.PBSystemIdMapping', param)
  return eGameRequest('fwGame.mappingSystemIdAdd', req)
}

export function mappingSystemIdUpdateRemark (param) {
  const req = proto.create('fwGame.PBSystemIdMapping', param)
  return eGameRequest('fwGame.mappingSystemIdUpdateRemark', req)
}

export function mappingSystemIdUpdateEnable (param) {
  const req = proto.create('fwGame.PBSystemIdMapping', param)
  return eGameRequest('fwGame.mappingSystemIdUpdateEnable', req)
}

/**
 * 待处理的匹配失败记录数
 */
export function mappingFailureRecordCount () {
  return eGameRequest('fwGame.mappingFailureRecordCount', null, 'framework.PBLongValue')
}

/**
 * 获取数据源，包括联赛源、游戏源、爬虫源
 */
export function leagueDataSourceList (param) {
  const req = proto.create('fwGame.PBLeagueDataSourceReq', param)
  return eGameRequest('fwGame.leagueDataSourceList', req, 'fwGame.PBLeagueDataSourceList')
}
export function leagueDataSourceUpdate (param) {
  const req = proto.create('fwGame.PBLeagueDataSource', param)
  return eGameRequest('fwGame.leagueDataSourceUpdate', req)
}
export function gameDataSourceList () {
  return eGameRequest('fwGame.gameDataSourceList', null, 'fwGame.PBGameDataSourceList')
}
export function spiderSourceList (param) {
  const req = proto.create('fwGame.PBSpiderSourceReq', param)
  return eGameRequest('fwGame.spiderSourceList', req, 'fwGame.PBSpiderSourceList')
}
export function spiderSourceAdd (param) {
  const req = proto.create('fwGame.PBSpiderSource', param)
  return eGameRequest('fwGame.spiderSourceAdd', req)
}
export function spiderSourceUpdate (param) {
  const req = proto.create('fwGame.PBSpiderSource', param)
  return eGameRequest('fwGame.spiderSourceUpdate', req)
}

/**
 * 直播源管理专区
 */

/**
 * 比赛直播添加
 * @param {PBLiveMatchAddReq} param LIVE_MATCH_ADD
 */
export function liveMatchAdd (param) {
  const req = proto.create('fwGame.PBLiveMatchAddReq', param)
  return eGameRequest('fwGame.liveMatchAdd', req)
}

/**
 * 比赛直播排序修改 LIVE_MATCH_UPDATE_SORT
 * @param {array} liveList
 */
export function liveMatchUpdateSort (liveList) {
  const req = proto.create('fwGame.PBLiveMatchList', { lives: liveList })
  return eGameRequest('fwGame.liveMatchUpdateSort', req)
}

/**
 * 比赛直播描述修改
 * @param {PBMatchLive} param LIVE_MATCH_UPDATE_DESC
 */
export function liveMatchUpdateDesc (param) {
  const req = proto.create('fwGame.PBLiveMatch', param)
  return eGameRequest('fwGame.liveMatchUpdateDesc', req)
}

/**
 * 比赛直播状态修改
 * @param {PBMatchLive} param LIVE_MATCH_UPDATE_ENABLE
 */
export function liveMatchUpdateEnable (param) {
  const req = proto.create('fwGame.PBLiveMatch', param)
  return eGameRequest('fwGame.liveMatchUpdateEnable', req)
}

/**
 * 比赛直播列表
 * @param {PBLiveMatchSearchReq} param LIVE_MATCH_LIST
 */
export function liveMatchList (param) {
  const req = proto.create('fwGame.PBLiveMatchSearchReq', param)
  return eGameRequest('fwGame.liveMatchList', req, 'fwGame.PBLiveMatchList')
}

/**
 * 比赛直播详情
 * @param {PBLongValue} param LIVE_MATCH_INFO
 */
export function liveMatchInfo (param) {
  const req = proto.create('framework.PBLongValue', param)
  return eGameRequest('fwGame.liveMatchInfo', req, 'fwGame.PBLiveMatch')
}

/**
 * 比赛直播统计列表
 * @param {PBMatchLiveStatsSearchReq} param LIVE_MATCH_STATS_LIST
 */
export function liveMatchStatsList (param) {
  const req = proto.create('fwGame.PBLiveMatchStatsSearchReq', param)
  return eGameRequest('fwGame.liveMatchStatsList', req, 'fwGame.PBLiveMatchStatsList')
}

/**
 * 比赛直播统计点击
 * @param {PBStrValue（中转url）} param LIVE_MATCH_STATS_CLICK
 */
// export function liveMatchStatsClick (param) {
//   const req = proto.create('fwGame.PBStrValue（中转url）', param)
//   return eGameRequest('fwGame.liveMatchStatsClick', req)
// }

/**
 * 直播源列表
 * @param {PBLiveSourceSearchReq} param LIVE_SOURCE_LIST
 */
export function liveSourceList (param) {
  const req = proto.create('fwGame.PBLiveSourceSearchReq', param)
  return eGameRequest('fwGame.liveSourceList', req, 'fwGame.PBLiveSourceList')
}

/**
 * 比赛直播名称修改
 * @param {PBLiveMatch} param LIVE_MATCH_UPDATE_NAME
 */
export function liveMatchUpdateName (param) {
  const req = proto.create('fwGame.PBLiveMatch', param)
  return eGameRequest('fwGame.liveMatchUpdateName', req)
}

/**
 * 直播源状态修改
 * @param {PBLiveSource} param LIVE_SOURCE_UPDATE_ENABLE
 */
export function liveSourceUpdateEnable (param) {
  const req = proto.create('fwGame.PBLiveSource', param)
  return eGameRequest('fwGame.liveSourceUpdateEnable', req)
}

/**
 * 直播源修改
 * @param {PBLiveSource} param LIVE_SOURCE_UPDATE
 */
export function liveSourceUpdate (param) {
  const req = proto.create('fwGame.PBLiveSource', param)
  return eGameRequest('fwGame.liveSourceUpdate', req)
}

/**
 * 直播源添加
 * @param {PBLiveSource} param LIVE_SOURCE_ADD
 */
export function liveSourceAdd (param) {
  const req = proto.create('fwGame.PBLiveSource', param)
  return eGameRequest('fwGame.liveSourceAdd', req)
}

/**
 * 比赛直播排序列表  /  LIVE_MATCH_SORT_LIST
 *  @param {PBLiveMatchSortReq} param
 */
export function liveMatchSortList (param) {
  const req = proto.create('fwGame.PBLiveMatchSortReq', param)
  return eGameRequest('fwGame.liveMatchSortList', req, 'fwGame.PBLiveMatchList')
}

/**
 * DATA_ALERT_COUNT_GET
 * 获取数据面板#数据管理  警报异常统计
 */
export function getDataAlertCount () {
  return eGameRequest('fwGame.dataAlertCountGet', null, 'fwGame.PBDataAlertCountList')
}

/**
 * DATA_ALERT_PROCESS
 * 更新数据异常状态
 */
export function updateDataAlertProcess (param) {
  const req = proto.create('fwGame.PBProcessDataAlertReq', param)
  return eGameRequest('fwGame.dataAlertProcess', req)
}



// WEBPACK FOOTER //
// ./src/api/egame/game.js